// extracted by mini-css-extract-plugin
export default {"container":"TermSwitchTab_container__i22me","tabItem":"TermSwitchTab_tab-item__1Q2Fa","highlight":"TermSwitchTab_highlight__pIk8N"};